<footer class="footer">
  <div class="version">
    <span>Version: {{ appVersion }}</span>
  </div>
</footer>
